import { render, staticRenderFns } from "./MessageCommentList.vue?vue&type=template&id=40bd95d7&scoped=true&"
import script from "./MessageCommentList.vue?vue&type=script&lang=js&"
export * from "./MessageCommentList.vue?vue&type=script&lang=js&"
import style0 from "./MessageCommentList.vue?vue&type=style&index=0&id=40bd95d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd95d7",
  null
  
)

export default component.exports